export function FilterContainer({ children }) {
  return (
    <div className="mb-6 bg-white rounded-xl shadow-sm border border-gray-200 p-4">
      <div className="flex flex-col sm:flex-row gap-3">{children}</div>
    </div>
  );
}
